import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import Utils from '@/utils';

import UserProfileImage from './UserProfileImage';

import './styles/ChatMessage.css';

export default function ChatMessage({ messageData, showAvatar = true }) {
  const { state } = useStateHandler();
  const messageRef = useRef(null);
  const [isSingleLine, setIsSingleLine] = useState(false);

  useEffect(() => {
    if (messageRef.current) {
      const computedStyle = window.getComputedStyle(messageRef.current);
      const lineHeight = parseFloat(computedStyle.lineHeight);
      const messageHeight = messageRef.current.offsetHeight;
      // If height is less than or equal to ~1.5 times lineHeight, assume a single line
      if (messageHeight <= lineHeight * 1.5) {
        setIsSingleLine(true);
      } else {
        setIsSingleLine(false);
      }
    }
  }, [messageData.message_text]);

  return (
    <div
      className={`chat-message__container ${
        state.user_session._id === messageData.message_sender._id ? "is-mine" : ""
      } ${isSingleLine ? "single-line" : ""}`}
    >
      {showAvatar && (
        <Link
          className="no-underline"
          to={`/user/${messageData.message_sender.user_username}`}
          state={{ from: true }}
        >
          <UserProfileImage
            image={messageData.message_sender.user_image?.image_id}
            typeOfProfile={messageData.message_sender.user_type}
            className="chat-message__user-image"
          />
        </Link>
      )}

      <div className="chat-message__message-container">
        <p ref={messageRef} className="chat-message__message font-size-medium">
          {messageData.message_text}
        </p>
        <span className="chat-message__time font-size-small">
          {Utils.getTimeOfMessageFromTimestamp(new Date(messageData.createdAt).getTime())}
        </span>
      </div>
    </div>
  );
}
